import IconPencil from "@/assets/images/pencil.svg";
import FotoUser from "@/assets/images/lg.png";
import { useState } from "react";

interface LogoProfileProps {
  name: string;
  email?: string;
  cargo?: string;
  handleImageUpload?: any;
  img?: any;
}

export function LogoProfile({
  name,
  email,
  cargo,
  img,
  handleImageUpload,
}: LogoProfileProps) {
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageChange = (event: any) => {
    const selectedFile = event.target.files[0];
    handleImageUpload(event.target.files[0]);

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Image = e.target?.result as string;
        setSelectedImage(base64Image);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center gap-6 pb-9">
      <label className="w-[150px] h-[150px] rounded-2xl relative">
        <img
          src={selectedImage || img || FotoUser}
          alt="Foto de perfil"
          className="object-cover w-[150px] h-[150px] rounded-2xl"
        />
        <div className="bg-azul-400 p-2 rounded-xl w-fit flex items-center justify-center absolute -bottom-2 -right-2 cursor-pointer">
          <input
            type="file"
            className="w-1 h-1 invisible"
            onChange={handleImageChange}
          />
          <img src={IconPencil} alt="Alterar foto de perfil" />
        </div>
      </label>
      <div className="text-center">
        <p className="text-2xl text-azul-400 font-medium">{name}</p>
        <div className="text-cinza-300">
          <p>{email}</p>
          <p>{cargo}</p>
        </div>
      </div>
    </div>
  );
}
